import {useDispatch, useSelector} from 'react-redux';

import useSession from 'hooks/useSession';
import useColor from 'hooks/useColor';

import draggable from 'helpers/Dragable';

import {Dominoes, Groupes} from 'redux/actions';
import Html from 'helpers/Html';


let startMove = false;
let imageCloneGroupClassName = 'image-clone-group';

const useGroup = () => {
	const dispatch = useDispatch();
	const {
		group,
		moveGroup,
		groupes,
		fetching,
		fetchingEstimate,
		loadedEstimate,
		estimate
	} = useSelector((state) => state.groupes);

	const {
		session,
		setup,
		getPixelValue
	} = useSession();

	const {
		colors
	} = useColor();

	const resetEstimate = () => {
		dispatch(Groupes.resetEstimate());
	}
	const estimateGroup = (params, callback) => {
		params.session = session;
		params.setup = setup;
		params.colors = colors;
		dispatch(Groupes.estimateGroup(params, callback));
	}

	const addGroup = (params, callback) => {
		if (typeof params.session === 'undefined') {
			params.session = session;
		}
		if (typeof params.setup === 'undefined') {
			params.setup = setup;
		}
		params.colors = colors;
		dispatch(Groupes.addGroup(params, callback));
	}

	const setCurrentGroup = (g) => {
		dispatch(Groupes.setCurrentGroup(g));
	}

	const deleteGroup = (g, callback) => {
		dispatch(Groupes.deleteGroup(g, callback));
	}

	const activeMoveGroup = (group) => {
		dispatch(Groupes.activeMoveGroup(group));
	}

	const setGroupes = (groupes) => {
		dispatch(Groupes.setGroupes(groupes));
	}

	const getDataGroupToBuild = (idSession, idGroup) => {
		dispatch(Groupes.getDataGroupToBuild(idSession, idGroup));
	}

	const updateBuildDetail = (id, detail) => {
		Groupes.updateBuildDetailWithoutRedux(id, detail);
	}

	const getCurrentGroup = (gp = false, ss = false) => {
		dispatch(Dominoes.getDominoByGroup({
			group: gp !== false ? gp.id : group.id,
			session: ss !== false ? ss : session
		}));

		if (gp !== false) {
			setCurrentGroup(gp);
		}
	}

	const disabledMoveGroup = (wrapper, currentZoom, selection, callback) => {
		let container = wrapper.current;
		let groupClone = container.querySelector('.' + imageCloneGroupClassName);
		if (groupClone !== null) {
			Html.removeClass(container, 'moved');
			let xClone = parseInt(groupClone.style.left.replace('px', ''), 10);
			let yClone = parseInt(groupClone.style.top.replace('px', ''), 10);

			let moveX = (xClone / currentZoom - startMove.x);
			let moveY = (yClone / currentZoom - startMove.y);

			groupClone.remove();

			let x = Math.round(moveX / (getPixelValue(setup.domino.size.thickness) + getPixelValue(setup.marginVertical)));
			let y = Math.round(moveY / (getPixelValue(setup.domino.size.width) + getPixelValue(setup.marginHorizontal)));


			if (setup.type === 2) {
				x = Math.round(moveX / (getPixelValue(setup.domino.size.width) + getPixelValue(setup.marginVertical)));
				y = Math.round(moveY / (getPixelValue(setup.domino.size.thickness) + getPixelValue(setup.marginHorizontal)));
			}

			if (setup.type === 3) {
				x = Math.round(moveX / (getPixelValue(setup.domino.size.width) + getPixelValue(setup.marginVertical)));
				y = Math.round(moveY / (getPixelValue(setup.domino.size.heightFallWall) + 1));
			}


			dispatch(
				Groupes.updateGroup({
						idGroup: group.id,
						moveX: x,
						moveY: y,
						session,
						...selection
					},
					callback
				)
			);
			return true;
		}
		return false
	}


	const getX = (x) => {

		let reelX = x * (getPixelValue(setup.domino.size.thickness) + getPixelValue(setup.marginVertical));

		if (setup.type === 2) {
			reelX = x * (getPixelValue(setup.domino.size.width) + getPixelValue(setup.marginVertical));
		}

		if (setup.type === 3) {
			reelX = x * (getPixelValue(setup.domino.size.width) + getPixelValue(setup.marginVertical));
		}

		return reelX;
	}

	const getY = (y) => {

		let reelY = y * (getPixelValue(setup.domino.size.width) + getPixelValue(setup.marginHorizontal));


		if (setup.type === 2) {
			reelY = y * (getPixelValue(setup.domino.size.thickness) + getPixelValue(setup.marginHorizontal));
		}

		if (setup.type === 3) {
			reelY = (getPixelValue(setup.domino.size.heightFallWall) + 1);
		}

		return reelY;
	}

	const updateZoom = (wrapper, currentZoom) => {
		let container = wrapper.current;
		let imageCloneGroup = container.querySelector('.' + imageCloneGroupClassName)
		if (imageCloneGroup === null) {
			return;
		}


		let width = imageCloneGroup.getAttribute('initial-width');
		let height = imageCloneGroup.getAttribute('initial-height');
		let x = imageCloneGroup.getAttribute('initial-x');
		let y = imageCloneGroup.getAttribute('initial-y');

		imageCloneGroup.style.top = (y * currentZoom) + 'px';
		imageCloneGroup.style.left = (x * currentZoom) + 'px';
		imageCloneGroup.setAttribute('width', (parseInt(width, 10) * currentZoom));
		imageCloneGroup.setAttribute('height', (parseInt(height, 10) * currentZoom));

		let borderY = getPixelValue(setup.marginVertical);
		let borderX = getPixelValue(setup.marginHorizontal);
		draggable(imageCloneGroup, {
			stepX: (getPixelValue(setup.domino.size.thickness) + borderX) * currentZoom,
			stepY: (getPixelValue(setup.domino.size.width) + borderY) * currentZoom
		});
	}

	const setMoveGroup = (canvas, context, wrapper, currentZoom, selection = false) => {
		let container = wrapper.current;
		let imageCloneGroup = container.querySelector('.' + imageCloneGroupClassName)
		if (imageCloneGroup !== null) {
			return;
		}
		Html.addClass(container, 'moved');

		const getImageURL = (imgData, width, height) => {
			let canvasTemp = document.createElement('canvas');
			var ctx = canvasTemp.getContext('2d');
			canvasTemp.width = width;
			canvasTemp.height = height;
			ctx.putImageData(imgData, 0, 0);
			ctx.scale(currentZoom, currentZoom);
			return canvasTemp.toDataURL(); //image URL
		}

		let width = getX(group.minMax.maxX + 1) - getX(group.minMax.minX);
		let height = getY(group.minMax.maxY + 1) - getY(group.minMax.minY);
		let x = getX(group.minMax.minX);
		let y = getY(group.minMax.minY);

		if (
			selection &&
			selection.x1 !== false &&
			selection.x2 !== false &&
			selection.y1 !== false &&
			selection.y2 !== false
		) {
			let xMin = (selection.x1 > selection.x2 ? selection.x2 : selection.x1);
			let xMax = (selection.x1 > selection.x2 ? selection.x1 : selection.x2);
			let yMin = (selection.y1 > selection.y2 ? selection.y2 : selection.y1);
			let yMax = (selection.y1 > selection.y2 ? selection.y1 : selection.y2);

			width = xMax - xMin;
			height = yMax - yMin;
			x = xMin;
			y = yMin;
		}

		startMove = {
			x,
			y
		};

		if (parseInt(width) === 0 || parseInt(height) === 0) {

			return;
		}
		let imageData = context.getImageData(
			x,
			y,
			width,
			height
		);

		let image = new Image();
		image.src = getImageURL(imageData, width, height);
		image.setAttribute('class', imageCloneGroupClassName);
		image.style.top = parseInt(y * currentZoom, 10) + 'px';
		image.style.left = parseInt(x * currentZoom, 10) + 'px';
		image.setAttribute('width', parseInt(width * currentZoom, 10));
		image.setAttribute('height', parseInt(height * currentZoom, 10));


		image.setAttribute('initial-width', width);
		image.setAttribute('initial-height', height);
		image.setAttribute('initial-x', x);
		image.setAttribute('initial-y', y);

		container.appendChild(image);

		let wrapperDragSize = Html.getElementSize(document.querySelector('.parent-canvas'));

		let borderX = getPixelValue(setup.marginVertical);
		let borderY = getPixelValue(setup.marginHorizontal);

		let stepX = (getPixelValue(setup.domino.size.thickness) + borderX) * currentZoom;
		let stepY = (getPixelValue(setup.domino.size.width) + borderY) * currentZoom;

		if (setup.type === 2) {
			stepX = (getPixelValue(setup.domino.size.width) + borderX) * currentZoom;
			stepY = (getPixelValue(setup.domino.size.thickness) + borderY) * currentZoom;
		}

		if (setup.type === 3) {
			stepX = (getPixelValue(setup.domino.size.width) + borderX) * currentZoom;
			stepY = (getPixelValue(setup.domino.size.heightFallWall) + 1) * currentZoom;
		}

		draggable(image, {
			stepX,
			stepY,
			minX: 0,
			minY: 0,
			maxY: wrapperDragSize.height - parseInt(height * currentZoom, 10),
			maxX: wrapperDragSize.width - parseInt(width * currentZoom, 10)
		});

	}

	return {
		setMoveGroup,
		disabledMoveGroup,
		groupes,
		group,
		setGroupes,
		addGroup,
		setCurrentGroup,
		activeMoveGroup,
		moveGroup,
		fetching,
		getCurrentGroup,
		deleteGroup,
		getDataGroupToBuild,
		updateBuildDetail,
		estimateGroup,
		updateZoom,
		fetchingEstimate,
		loadedEstimate,
		estimate,
		resetEstimate
	};
};

export default useGroup;
